module.exports = __webpack_public_path__ + "img/cpw.06e09f16.jpg";